const authfxReducerDefaultState = {
  userinfo: {
    phone_number: '',
    phone_number_verified: false,
    name: '',
    family_name: '',
    given_name: '',
    picture: '',
    email: '',
    email_verified: false
  },
};

export default (state = authfxReducerDefaultState, action) => {
  switch (action.type) {
    case 'USERINFO':
      return {
        ...state,
        userinfo: action.userinfo
      }
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/reducers/authfx.js